// extracted by mini-css-extract-plugin
export default {"section":"Services_section__Q-sZD","sectionList":"Services_sectionList__rF+oO"};